import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { HiOutlineLockClosed } from "react-icons/hi";
import { BoardAccess, normalizeBoardAccess } from "../../../../types/TodoTypes";

interface Props {
  access?: BoardAccess;
  className?: string;
}

const BoardAccessBadge: React.FC<Props> = ({ access, className }) => {
  const { t } = useTranslation();
  const normalized = normalizeBoardAccess(access);
  if (normalized.mode !== "restricted") return null;

  const count = normalized.user_ids.length;
  const label =
    count > 0
      ? (t("todos.access.badgeCount", { count }) as string)
      : (t("todos.access.badge") as string);

  return (
    <span
      className={twMerge(
        "inline-flex items-center gap-1 text-xs text-gray-500",
        className
      )}
      title={t("todos.access.badgeTooltip") as string}
    >
      <HiOutlineLockClosed size={12} className="shrink-0" />
      <span className="truncate">{label}</span>
    </span>
  );
};

export default BoardAccessBadge;
